<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.25 2.25H7.5V7.5H2.25V2.25ZM2.25 10.5H7.5V15.75H2.25V10.5ZM10.5 2.25H15.75V7.5H10.5V2.25ZM10.5 10.5H15.75V15.75H10.5V10.5Z"
      fill="#303133"
    />
  </svg>
</template>
